// extracted by mini-css-extract-plugin
module.exports = {"galleryFirstElement":"InstagramSection_galleryFirstElement__5oRih","galleryLastElement":"InstagramSection_galleryLastElement__CQtB_"};